'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/detail/lang/lang.controller'
],function(angular,SinglePageLangCtrl){
    var app=angular.module('app.seospider.exam.analysis.detail.lang', []);
    app.controller('SinglePageLangCtrl',SinglePageLangCtrl);
    return app;
});